
import './App.css'

import Register from './Components/pages/register'
import HomePage from './Components/pages/homePage';
import Maintenance from './Components/pages/maintenance';
import Scholarship from './Components/pages/scholarship';
import School from './Components/pages/school';
import Recruitment from './Components/pages/recruitment'
import Nursing from './Components/pages/nursing'
import OldStudent from './Components/pages/oldStudent'
import { BrowserRouter, Routes, Route, Link } from 'react-router-dom';
import { Fragment } from 'react';

function App() {
  let currentDate = new Date();
  let hour = currentDate.getHours();
  if(hour >= 6 && hour <= 23)
  {
    return (

      <BrowserRouter>
     
      
        <Routes>
         
          <Route path="/" element={<HomePage />} />
        <Route path="register/:id" element={<Register />} />
          
        <Route path="school/:id" element={<School />} />
        <Route path="scholarship" element={<Scholarship />} />
        <Route path="recruit" element={<Recruitment />} />
        <Route path="nursing" element={<Nursing />} />
        <Route path="alumni" element={<OldStudent />} />
        </Routes>
        
      </BrowserRouter>
        );
  }
  else{
    return(
      <BrowserRouter>
      <div className='App'>
        <Routes>
        <Route path="*" element={<Maintenance />} />
        </Routes>
      </div>
      </BrowserRouter>
    );
  }
  
  
}

export default App;
